import { useState } from 'react';
import styled from '@emotion/styled';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import { theme } from '@myme/utils';
import { mq } from 'src/themes';
import { useSearchContext } from 'src/contexts/SearchContext';
import { useTranslation } from 'src/hooks';
import { SvgIcon, TextField } from 'src/components/atoms';

const StyledSearchBar = styled(TextField)(
  props => `
  background-color: ${props.theme.palette.common.white};
  border-radius: 8px;
  width: 70%;
  max-width: 65rem;
  min-width: 20rem;
  margin-right: 10rem;

  ${mq.md} {
    width: 100%;
    min-width: auto;
  }

  input {
    font-size: ${props.theme.typography.body2.fontSize};
    color: ${props.theme.palette.common.black};
    padding: 0.5rem;
    padding-left: 0;

    &::placeholder {
      color: ${theme.colors.grey};
      opacity: 0.9;
    }
  }
`
);

export const SearchBar = () => {
  const { t } = useTranslation();
  const { searchField, handleChangeSearchField, chips } = useSearchContext();
  const [error, setError] = useState<string | null>(null);

  const handleKeyUp = () => {
    if (error && (searchField.length >= 3 || searchField.length === 0)) {
      setError(null);
    }

    if (searchField.length < 3 && searchField.length > 0 && !chips.some(chip => chip.isSelected)) {
      setError(t('pages.search_results.search_too_short'));
    }
  };

  return (
    <StyledSearchBar
      hiddenLabel
      size='small'
      variant='filled'
      value={searchField}
      onChange={handleChangeSearchField}
      onKeyUp={handleKeyUp}
      error={!!error}
      helperText={error}
      placeholder={t('layout.search_bar')}
      InputProps={{
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position='start' sx={{ mt: '0 !important' }}>
            <SvgIcon htmlColor={theme.colors.grey}>
              <SearchIcon />
            </SvgIcon>
          </InputAdornment>
        )
      }}
    />
  );
};
